<template>
  <div>
    <div class="signature-container" v-touch:start="onSignStart" v-touch:end="onSignEnd" :style="containerStyle">
      <VueSignaturePad ref="signaturePad"
                       :options=" { onEnd: save, backgroundColor: 'rgb(255,255,255)' } " />
      <icon class="edit-icon" name="edit" size="18px"/>
    </div>
    <div class="footer">
      <div class="signing-date">{{ signingDate }}</div>
      <icon name="trash" @click="clear"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import dayjs from 'dayjs';
import Vue2TouchEvents from 'vue2-touch-events';
import Icon from './Icon.vue';

Vue.use(Vue2TouchEvents);

export default {
  name: 'Signature',
  components: { Icon },
  props: {
    height: {
      type: String,
    },
    width: String,
  },
  data() {
    return {
      signing: false,
      signature: undefined,
    };
  },
  computed: {
    signingDate() {
      return dayjs().format('D.M.YY');
    },
    containerStyle() {
      const borderStyle = this.signing ? { '--border-opacity': 1 } : { '--border-opacity': 0.25 };
      return { ...borderStyle, height: this.height };
    },

  },
  methods: {
    save() {
      const { data } = this.$refs.signaturePad.saveSignature('image/jpeg');
      this.signature = data;
      this.$emit('signed', data);
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
      this.signature = undefined;
      this.$emit('signed', undefined);
    },
    onSignStart() {
      this.signing = true;
    },
    onSignEnd() {
      this.signing = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/riseup-colors";

.signature-container {
  position: relative;
  --border-opacity: 0.25;
  border: 1px solid rgba($riseup_blue, var(--border-opacity));
  border-radius: 2px;

  .edit-icon {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-items: center;
  margin-top: 8px;

  .signing-date {
    text-align: right;
    font-size: 14px;
    line-height: 1.2em;
  }
}

</style>
